/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Credit_Trial_DescriptionInputs */

const en_video_credit_trial_description = /** @type {(inputs: Video_Credit_Trial_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 4-second 480p preview costs 1 credit. Longer or 720p clips cost more, and the price is shown before you confirm.`)
};

const es_video_credit_trial_description = /** @type {(inputs: Video_Credit_Trial_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vista previa de 4 segundos a 480p cuesta 1 crédito. Los clips más largos o en 720p cuestan más, y el precio se muestra antes de confirmar.`)
};

/**
* | output |
* | --- |
* | "A 4-second 480p preview costs 1 credit. Longer or 720p clips cost more, and the price is shown before you confirm." |
*
* @param {Video_Credit_Trial_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const video_credit_trial_description = /** @type {((inputs?: Video_Credit_Trial_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Credit_Trial_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_credit_trial_description(inputs)
	return es_video_credit_trial_description(inputs)
});